import { render, staticRenderFns } from "./purchasesReturnsEdit_v2.vue?vue&type=template&id=06d8d365&scoped=true&"
import script from "./purchasesReturnsEdit_v2.vue?vue&type=script&lang=js&"
export * from "./purchasesReturnsEdit_v2.vue?vue&type=script&lang=js&"
import style0 from "./purchasesReturnsEdit_v2.vue?vue&type=style&index=0&id=06d8d365&lang=less&scoped=true&"
import style1 from "./purchasesReturnsEdit_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8d365",
  null
  
)

component.options.__file = "purchasesReturnsEdit_v2.vue"
export default component.exports